import Reports from './ReportsDefaultController';

export default Reports;
